import React, { useEffect, useState } from "react";
import Banner from "../../assest/teacher.png";
import "./Login.css";
import { toast } from "react-toastify";
import Loginlayout from "./Component/Loginlayout";
import Loader from "../Loader/Loader";
import { Domain, Workspace } from "../../path";
import ModalScreenlayout from "./Component/ModalScreenlayout";
import { useNavigate } from "react-router-dom";
import usePost from "../../Hooks/usePost";
import { useDispatch } from "react-redux";
import { Set_Loader } from "../../Redux/Action/LoaderAction";

const Login = () => {
  const Navigation = useNavigate();
  const Dispatch = useDispatch();
  const [Login, setLogin] = useState({
    opt_send: false,
    number: "",
    otp: "",
  });

  // ================================MODAL SCREENS================================
  const [ModalScreen, setModalScreen] = useState({
    is_awareness: false,
    is_new: false,
    is_mail: false,
  });
  // ================================NEW USER FORM DATA================================
  const [Newuser, setNewuser] = useState({
    name: "",
    mobile: "",
    email: "",
    message: "",
  });
  //================================ RESEND OTP COUNT================================
  const [ResendCount, setResendCount] = useState(30);
  //================================ API FETCH FOR MOBILE NUMBER================================
  const Mobileno = usePost(`${Workspace[Domain].API_Path}/check_user`);
  const Otp = usePost(`${Workspace[Domain].API_Path}/validate_otp`);
  const Form = usePost(`${Workspace[Domain].API_Path}/c_call_back_form`);

  //================================ MOBILE NUMBER HANDLER================================
  const Mobile_No_Handler = (e) => {
    e.target.value = e.target.value?.replace(/[^0-9]/, "");
    setLogin({
      opt_send: false,
      number: e.target.value.slice(0, 10),
      otp: "",
    });
  };

  // ================================VALIDATE MOBILE NO AND SEND MOBILE NO================================
  const LoginHandler = () => {
    if (Login.number == "") {
      toast.warn("Enter mobile number");
      toast.clearWaitingQueue();
      return;
    }
    if (Login.number?.length < 10) {
      toast.warn("Invalid mobile no");
      toast.clearWaitingQueue();
      return;
    }

    // if (!Login.number >= 5999999999) {
    //   toast.warn("Invalid mobile no");
    //   toast.clearWaitingQueue();
    //   return;
    // }

    Post_Mobilenumber(Login.number);
  };

  // ================================OTP HANDLER================================
  const Otp_Handler = (e) => {
    e.target.value = e.target.value?.replace(/[^0-9]/, "");
    setLogin((prev) => ({ ...prev, otp: e.target.value.slice(0, 4) }));
  };

  //================================ VALIDATE OTP AND VERIFY OTP================================
  const Verify_OTP_handler = () => {
    if (Login.otp == "") {
      toast.warn("Enter Otp");
      toast.clearWaitingQueue();
      return;
    }
    if (Login.otp?.length < 4) {
      toast.warn("Enter 4 digit Otp");
      toast.clearWaitingQueue();
      return;
    }

    Submit_Otp_Handler();
  };

  //================================ CHANGE NUMBER HANDLER================================
  const Change_NumberHandler = () => {
    setLogin({
      opt_send: false,
      number: "",
      otp: "",
    });
  };

  //================================RESEND OTP================================
  const Resend_Otp_Handler = () => {
    Post_Mobilenumber(Login?.number);
  };

  //================================ CLOSE AWARENESS MODAL================================
  const Close_AwarenessHandler = () => {
    setModalScreen((prev) => ({ ...prev, is_awareness: false }));
  };

  //================================ CLOSE NEW MODAL================================
  const Close_NewModalHandler = () => {
    setModalScreen((prev) => ({
      ...prev,
      is_new: false,
      is_awareness: false,
      is_mail: false,
    }));
    setNewuser((prev) => ({
      ...prev,
      name: "",
      message: "",
      mobile: "",
      email: "",
    }));
  };
  // ================================USER NAME HANDLER ==================================
  const User_nameHandler = (e) => {
    e.target.value = e.target.value?.replace(/[^a-zA-Z ]/, "");
    setNewuser((prev) => ({ ...prev, name: e.target.value?.slice(0, 60) }));
  };
  // ================================USER MOBILE HANDLER ==================================
  const User_MobileHandler = (e) => {
    e.target.value = e.target.value?.replace(/[^0-9]/, "");
    setNewuser((prev) => ({ ...prev, mobile: e.target.value?.slice(0, 10) }));
  };
  // ================================USER EMAIL HANDLER ==================================
  const User_EmailHandler = (e) => {
    e.target.value = e.target.value?.replace(/[^a-z]@/, "");
    setNewuser((prev) => ({ ...prev, email: e.target.value?.slice(0, 50) }));
  };
  // ================================USER MESSAGE HANDLER ==================================

  const User_MessageHandler = (e) => {
    e.target.value = e.target.value?.replace(/[^a-z 0-9A-Z.,"]/, "");
    setNewuser((prev) => ({ ...prev, message: e.target.value?.slice(0, 50) }));
  };

  // ================================API CALLS START==================================
  // ================================ VALIDATE USER AND MOBILE NUMBER ================================
  const Post_Mobilenumber = (number) => {
    Mobileno.Postcall({ mobile_number: number });
  };

  //================================ SUBMIT OTP ================================
  const Submit_Otp_Handler = () => {
    Otp.Postcall({ mobile_number: Login?.number, otp: Login?.otp });
  };

  //================================ SUBMIT NEW USER================================
  const Submit_NewUserHandler = () => {
    if (Newuser?.name == "") {
      toast.warn("Kindly fill the name");
      toast.clearWaitingQueue();
      return;
    }
    if (Newuser?.mobile == "") {
      toast.warn("Kindly fill the mobile no");
      toast.clearWaitingQueue();
      return;
    }
    if (Newuser?.mobile.length < 10) {
      toast.warn("Invalid mobile no");
      toast.clearWaitingQueue();
      return;
    }
    if (Newuser?.email == "") {
      toast.warn("Kindly fill the email address");
      toast.clearWaitingQueue();
      return;
    }
    if (!Newuser?.email.includes("@")) {
      toast.warn("Invalid email address");
      toast.clearWaitingQueue();
      return;
    }
    Form.Postcall({
      mobile_number: Newuser?.mobile,
      teacher_name: Newuser?.name,
      teacher_email: Newuser?.email,
      message: Newuser?.message,
    });
  };
  // ================================API CALLS END==================================

  useEffect(() => {
    const interval = setInterval(() => {
      if (ResendCount <= 0) {
        clearInterval(interval);
      } else {
        setResendCount(ResendCount - 1);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [ResendCount]);

  useEffect(() => {
    return () => {
      setLogin((prev) => ({ ...prev, opt_send: false, number: "", otp: "" }));
      setModalScreen((prev) => ({
        ...prev,
        is_awareness: false,
        is_new: false,
        is_mail: false,
      }));
      setNewuser((prev) => ({
        ...prev,
        name: "",
        mobile: "",
        email: "",
        message: "",
      }));
      setResendCount(30);
    };
  }, []);

  // MOBILE NUMBER CHECK
  useEffect(() => {
    if (Mobileno.Post != null) {
      switch (Mobileno.Post.status) {
        case 200:
          setLogin((prev) => ({ ...prev, opt_send: true, otp: "" }));
          setResendCount(30);
          setModalScreen((prev) => ({
            ...prev,
            is_new: false,
            is_awareness: false,
          }));
          Dispatch(Set_Loader(false));
          break;
        case 400:
          if (Mobileno.Post?.body.status == "completed") {
            setModalScreen((prev) => ({
              ...prev,
              is_new: true,
              is_awareness: false,
            }));
          } else if (Mobileno.Post?.body.status == "incompleted") {
            setModalScreen((prev) => ({
              ...prev,
              is_awareness: true,
              is_new: false,
            }));
          }
          Dispatch(Set_Loader(false));
          break;

        default:
          Dispatch(Set_Loader(false));
          break;
      }
    }
  }, [Mobileno.Post]);

  // OTP CHECK
  useEffect(() => {
    if (Otp.Post != null) {
      switch (Otp.Post.status) {
        case 200:
          localStorage.setItem(
            "TEACHER_TOKEN",
            Otp.Post.body?.encode_token_data
          );
          Navigation(`/`, { replace: true });
          toast.success("Welcome to teacher portal");
          toast.clearWaitingQueue();
          Dispatch(Set_Loader(false));
          break;
        case 400:
          toast.error("Invalid otp");
          toast.clearWaitingQueue();
          Dispatch(Set_Loader(false));
          break;
        default:
          break;
      }
    }
  }, [Otp.Post]);

  useEffect(() => {
    if (Form.Post != null) {
      switch (Form.Post.status) {
        case 200:
          if (Form.Post?.body?.success) {
            setModalScreen((prev) => ({ ...prev, is_mail: true }));
          } else {
            toast.error(Form.Post?.body?.msg);
            toast.clearWaitingQueue();
          }
          Dispatch(Set_Loader(false));
          break;

        default:
          break;
      }
    }
  }, [Form.Post]);

  return (
    <>
      <Loginlayout
        Banner={Banner}
        Login={Login}
        Mobile_No_Handler={Mobile_No_Handler}
        LoginHandler={LoginHandler}
        Otp_Handler={Otp_Handler}
        Verify_OTP_handler={Verify_OTP_handler}
        Change_NumberHandler={Change_NumberHandler}
        Resend_Otp_Handler={Resend_Otp_Handler}
        ResendCount={ResendCount}
      />

      {(ModalScreen.is_awareness || ModalScreen.is_new) && (
        <ModalScreenlayout
          ModalScreen={ModalScreen}
          Newuser={Newuser}
          User_nameHandler={User_nameHandler}
          User_MobileHandler={User_MobileHandler}
          User_EmailHandler={User_EmailHandler}
          User_MessageHandler={User_MessageHandler}
          Close_NewModalHandler={Close_NewModalHandler}
          Submit_NewUserHandler={Submit_NewUserHandler}
          Close_AwarenessHandler={Close_AwarenessHandler}
        />
      )}
    </>
  );
};

export default Login;
